// Wrap in IIFE to avoid conflicts and check if class already exists
(function() {
  'use strict';
  
  // Check if the class already exists
  if (window.ImageGallerySwiper) {
    console.log('ImageGallerySwiper already exists, skipping initialization');
    return;
  }
  
  class ImageGallerySwiper {
    constructor() {
      this.swipers = new Map();
      this.init();
    }

  init() {
    // Buscar todos los sliders de image-gallery
    const sliders = document.querySelectorAll('slider-component[data-section-id*="image-gallery"]');
    
    sliders.forEach((slider) => {
      this.initSwiper(slider);
    });

    // Escuchar cambios en el DOM para nuevas secciones
    this.observeDOMChanges();
  }

  initSwiper(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    
    // If a Swiper already exists for this section, destroy it
    if (this.swipers.has(sectionId)) {
      this.swipers.get(sectionId).destroy();
      this.swipers.delete(sectionId);
    }

    // Clean up any existing resize observers/handlers
    this.cleanupResizeEvents(sliderElement);

    // Get configuration from data attributes
    const config = this.getSwiperConfig(sliderElement);
    
    // Buscar el contenedor de slides
    const slidesContainer = sliderElement.querySelector('.swiper');
    
    if (!slidesContainer) {
      console.warn(`No se encontró el contenedor de slides para la sección ${sectionId}`);
      return;
    }

    try {
      // Crear nueva instancia de Swiper
      const swiper = new Swiper(slidesContainer, config);
      
      // Guardar referencia
      this.swipers.set(sectionId, swiper);
      
      // Agregar eventos personalizados
      this.addCustomEvents(swiper, sliderElement, sectionId);
      
      console.log(`Image Gallery Swiper inicializado para la sección ${sectionId}`, config);
      
    } catch (error) {
      console.error(`Error al inicializar Image Gallery Swiper para la sección ${sectionId}:`, error);
    }
  }

  getSwiperConfig(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    
    // Get values from data attributes
    const slidesDesktop = parseInt(sliderElement.dataset.columnsDesktop) || 1;
    const enableAutoplay = sliderElement.dataset.enableAutoplay === 'true';
    const autoplayDelay = parseInt(sliderElement.dataset.autoplayDelay) || 5000;
    const pauseOnHover = sliderElement.dataset.pauseOnHover === 'true';
    const enableLoop = sliderElement.dataset.enableLoop === 'true';
    const spaceBetween = parseInt(sliderElement.dataset.spaceBetween) || 0;

    // Base configuration for image-gallery
    const config = {
      slidesPerView: 1,
      spaceBetween: spaceBetween,
      loop: enableLoop,
      centeredSlides: false,
      navigation: {
        nextEl: sliderElement.querySelector('.slider-button--next'),
        prevEl: sliderElement.querySelector('.slider-button--prev'),
      },
      pagination: {
        el: sliderElement.querySelector('.slider-counter'),
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return number;
        },
        formatFractionTotal: function (number) {
          return number;
        }
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        768: {
          slidesPerView: Math.min(slidesDesktop, 2),
          spaceBetween: spaceBetween
        },
        1024: {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceBetween
        }
      },
      // Callbacks
      on: {
        init: (swiper) => {
          this.onSwiperInit(swiper, sliderElement, sectionId);
        },
        slideChange: (swiper) => {
          this.onSlideChange(swiper, sliderElement, sectionId);
        }
      }
    };

    // Add autoplay if enabled
    if (enableAutoplay) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover
      };
    }

    return config;
  }

  addCustomEvents(swiper, sliderElement, sectionId) {
    // Custom event to update counters
    swiper.on('slideChange', () => {
      this.updateCounters(sliderElement, swiper);
    });

    // Event to pause/resume autoplay
    const pauseOnHover = sliderElement.dataset.pauseOnHover === 'true';
    
    if (pauseOnHover && swiper.autoplay) {
      sliderElement.addEventListener('mouseenter', () => {
        swiper.autoplay.stop();
      });
      
      sliderElement.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
      });
    }

    // Add resize event to update slides per view dynamically
    const handleResize = () => {
      // Delay execution to ensure DOM updates are complete
      setTimeout(() => {
        this.updateSlidesPerView(swiper, sliderElement);
      }, 100);
    };

    // Use ResizeObserver for better performance when available
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(sliderElement);
      
      // Store observer reference for cleanup
      sliderElement._resizeObserver = resizeObserver;
    } else {
      // Fallback to window resize event
      window.addEventListener('resize', handleResize);
      
      // Store event handler reference for cleanup
      sliderElement._resizeHandler = handleResize;
    }

    // Add keyboard events for accessibility
    sliderElement.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        swiper.slidePrev();
      } else if (event.key === 'ArrowRight') {
        swiper.slideNext();
      }
    });

    // Add swipe events for mobile
    let startX = 0;
    let startY = 0;

    sliderElement.addEventListener('touchstart', (event) => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    sliderElement.addEventListener('touchend', (event) => {
      if (!startX || !startY) return;

      const endX = event.changedTouches[0].clientX;
      const endY = event.changedTouches[0].clientY;
      const diffX = startX - endX;
      const diffY = startY - endY;

      // Only process if horizontal swipe is greater than vertical
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }
      }

      startX = 0;
      startY = 0;
    }, { passive: true });
  }

  updateCounters(sliderElement, swiper) {
    const currentCounter = sliderElement.querySelector('.slider-counter--current');
    const totalCounter = sliderElement.querySelector('.slider-counter--total');
    
    if (currentCounter) {
      currentCounter.textContent = swiper.realIndex + 1;
    }
    
    if (totalCounter) {
      totalCounter.textContent = swiper.slides.length;
    }
  }

  updateSlidesPerView(swiper, sliderElement) {
    // Get current viewport width
    const windowWidth = window.innerWidth;
    
    // Get configuration from data attributes
    const slidesDesktop = parseInt(sliderElement.dataset.columnsDesktop) || 1;
    const spaceBetween = parseInt(sliderElement.dataset.spaceBetween) || 0;
    
    // Calculate slides per view based on current viewport
    let newSlidesPerView = 1;
    let newSpaceBetween = 0;
    
    if (windowWidth >= 1024) {
      // Desktop
      newSlidesPerView = slidesDesktop;
      newSpaceBetween = spaceBetween;
    } else if (windowWidth >= 768) {
      // Tablet
      newSlidesPerView = Math.min(slidesDesktop, 2);
      newSpaceBetween = spaceBetween;
    } else {
      // Mobile
      newSlidesPerView = 1;
      newSpaceBetween = 0;
    }
    
    // Only update if values have changed
    const currentSlidesPerView = swiper.params.slidesPerView;
    const currentSpaceBetween = swiper.params.spaceBetween;
    
    if (newSlidesPerView !== currentSlidesPerView || newSpaceBetween !== currentSpaceBetween) {
      // Update swiper parameters
      swiper.params.slidesPerView = newSlidesPerView;
      swiper.params.spaceBetween = newSpaceBetween;
      
      // Update the swiper
      swiper.update();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      
      // Update counters after slides per view change
      this.updateCounters(sliderElement, swiper);
      
      // Log the change for debugging
      console.log(`Image Gallery Swiper updated for viewport ${windowWidth}px: ${newSlidesPerView} slides per view, ${newSpaceBetween}px space between`);
      
      // Dispatch custom event for other components that might need to know
      sliderElement.dispatchEvent(new CustomEvent('slidesPerViewChanged', {
        detail: {
          slidesPerView: newSlidesPerView,
          spaceBetween: newSpaceBetween,
          viewport: windowWidth
        }
      }));
    }
  }

  onSwiperInit(swiper, sliderElement, sectionId) {
    console.log(`Swiper inicializado para image-gallery ${sectionId}`);
    
    // Update counters on init
    this.updateCounters(sliderElement, swiper);
    
    // Show/hide navigation buttons based on slides count
    const prevButton = sliderElement.querySelector('.slider-button--prev');
    const nextButton = sliderElement.querySelector('.slider-button--next');
    
    if (prevButton && nextButton) {
      if (swiper.slides.length <= 1) {
        prevButton.style.display = 'none';
        nextButton.style.display = 'none';
      } else {
        prevButton.style.display = 'flex';
        nextButton.style.display = 'flex';
      }
    }
  }

  onSlideChange(swiper, sliderElement, sectionId) {
    console.log(`Slide changed for image-gallery ${sectionId}: ${swiper.realIndex + 1}/${swiper.slides.length}`);
    
    // Update counters
    this.updateCounters(sliderElement, swiper);
  }

  observeDOMChanges() {
    // Observe DOM changes to detect new sections
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Look for new sliders in the added node
            const newSliders = node.querySelectorAll ? 
              node.querySelectorAll('slider-component[data-section-id*="image-gallery"]') : 
              (node.nodeName === 'SLIDER-COMPONENT' && node.dataset.sectionId && node.dataset.sectionId.includes('image-gallery') ? [node] : []);
            
            newSliders.forEach((slider) => {
              this.initSwiper(slider);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Method to clean up resize events
  cleanupResizeEvents(sliderElement) {
    // Clean up ResizeObserver if it exists
    if (sliderElement._resizeObserver) {
      sliderElement._resizeObserver.disconnect();
      delete sliderElement._resizeObserver;
    }
    
    // Clean up window resize handler if it exists
    if (sliderElement._resizeHandler) {
      window.removeEventListener('resize', sliderElement._resizeHandler);
      delete sliderElement._resizeHandler;
    }
  }

  // Method to reinitialize a specific slider
  reinitSwiper(sectionId) {
    const sliderElement = document.querySelector(`slider-component[data-section-id="${sectionId}"]`);
    if (sliderElement) {
      this.initSwiper(sliderElement);
    }
  }
}

  // Make class available globally
  window.ImageGallerySwiper = ImageGallerySwiper;

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded. Make sure to include the Swiper library.');
      return;
    }

    // Crear instancia global
    window.imageGallerySwiper = new ImageGallerySwiper();
  });

  // Also initialize on Shopify events
  document.addEventListener('shopify:section:load', function(event) {
    if (window.imageGallerySwiper) {
      const sliderElement = event.target.querySelector('slider-component[data-section-id*="image-gallery"]');
      if (sliderElement) {
        window.imageGallerySwiper.initSwiper(sliderElement);
      }
    }
  });

})(); // Close IIFE